import React, { useMemo } from "react";
import { IconButton } from "@bloomberg/media-ui-core";
import { Close } from "@bloomberg/media.icons";
import styles from "./holdingsDrawer.module.css";
import DrawerShell from "./DrawerShell";
import DrawerTickerHeader from "./DrawerTickerHeader";
import DrawerOverview from "./DrawerOverview";
import {
  useCurrentWatchlist,
  useIsDrawerOpen,
  useSelectedTicker,
  useWatchlistActions,
} from "~context/WatchlistContext";

export default function HoldingsDrawer() {
  const isOpen = useIsDrawerOpen();
  const selectedTicker = useSelectedTicker();
  const currentWatchlist = useCurrentWatchlist();
  const { closeDrawer } = useWatchlistActions();

  const position = useMemo(() => {
    if (!selectedTicker || !currentWatchlist?.positions) return null;

    return (
      currentWatchlist.positions.find((p) => p.ticker === selectedTicker) ??
      null
    );
  }, [selectedTicker, currentWatchlist]);

  const title = position?.marketData.longName ?? selectedTicker ?? "";
  const price = position?.marketData.price ?? null;
  const currency = position?.marketData.issuedCurrency ?? "USD";
  const percentChange = position?.marketData.percentChange1Day ?? null;

  const subtitle = (
    <DrawerTickerHeader
      price={price}
      currency={currency}
      percentChange={percentChange}
    />
  );

  const headerRight = (
    <IconButton size="small" onClick={closeDrawer} aria-label="Close">
      <Close />
    </IconButton>
  );

  const footer = (
    <div className={styles.footer}>
      <button type="button" className={styles.deleteButton}>
        Delete
      </button>
      <button type="button" className={styles.addButton}>
        Add Holdings
      </button>
    </div>
  );

  return (
    <DrawerShell
      isOpen={isOpen}
      onClose={closeDrawer}
      title={title}
      headerRight={headerRight}
      subtitle={subtitle}
      footer={footer}
    >
      <div className={styles.content}>
        <DrawerOverview position={position} />
        <section>
          <h3 className={styles.sectionTitle}>History</h3>
          <p className={styles.placeholder}>
            Holdings history will be implemented in DELTA-303.
          </p>
        </section>
      </div>
    </DrawerShell>
  );
}
